module.exports = __webpack_public_path__ + "media/howellcare_main_mobile.8bdb3286.mp4";